export const BuildInfo = {timestamp:1788217190000}
